import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

import { useAuth } from "../contexts/AuthContext";
import axios from "../scripts/axiosConfig";
import { getCustomClaim } from "../scripts/Misc";

import "../styles/Leaderboard.scss";

const Leaderboard: React.FC = () => {

    const {  currentUser, userJson } = useAuth();
    const { contestSlug } = useParams<{ contestSlug: string }>();

    const [delayQuery, setDelayQuery] = useState(false);

    const fetchContestDetails = async () => {
        let idToken = "";
        if (currentUser && currentUser !== "none") {
            idToken = await getCustomClaim(currentUser, "id")
        }

        const { data } = await axios.post(`/leaderboard/${contestSlug}`, {});

        return data;
    };

    useEffect(() => {
        if (currentUser || currentUser === "none") {
            setDelayQuery(true);
        }
    }, [currentUser, userJson]);

    type LeaderboardRecord = {
        username: string,
        totalScore: number,
    }

    const { data, error, isLoading, isPending } = useQuery<{ contestName: string, leaderboard: any[] }>(
        {
            queryKey: ['contest', contestSlug],
            queryFn: fetchContestDetails,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            enabled: delayQuery,
        }
    );

    const rankedData = useMemo(
        () =>
          data?.leaderboard?.map((row, index) => ({
            ...row,
            rank: `#${index + 1}`,
          })) || [],
        [data]
      );

    const columns = useMemo(
        () => [
            {
                header: 'Rank',
                accessorKey: 'rank',
            },
            {
                accessorKey: 'username',
                header: 'Username',
            },
            {
                header: 'Score',
                accessorKey: 'totalScore',
            },
        ],
        [],
    );

    const table = useMaterialReactTable({
        columns,
        data: rankedData || [],
        enableSorting: false,
        enableFilters: false,
        enableRowActions: false,
        enableColumnActions: false,
        enableDensityToggle: false,
        enableColumnFilterModes: false,
        enableHiding: false,
    });

    return (
        <>

            <div className="Leaderboard">

                <div className="header">
                    <h1>Leaderboard for { data?.contestName || contestSlug}</h1>
                </div>

                <div className="content">

                    {
                        (isLoading || isPending) ? (
                            <div className="loading">
                                <p>Loading...</p>
                            </div>
                        ) : (
                            <div className="tableContainer">
                                <MaterialReactTable 
                                    table={table} 
                                />
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )


}


export default Leaderboard;